import { Rect } from '@sierralabs/workflow';

import { Connector, EntityManager } from '.';

export class Entity {
  public _rect: Rect;
  public readonly connectors: Connector[] = [];

  constructor(
    protected readonly manager: EntityManager,
    public readonly id: string
  ) {
    this._rect = new Rect();
  }

  get rect(): Rect {
    const { el, manager } = this;
    if (el) {
      const { offset, scrollOffset } = manager;
      this._rect.setFromElement(el, scrollOffset);
      this._rect.set({ offsetX: offset.x, offsetY: offset.y });
    }
    return this._rect;
  }

  get el(): HTMLElement | null {
    return (
      this.manager.rootEl?.querySelector(`*[data-entity-id="${this.id}"]`) ||
      null
    );
  }

  connect(to: Entity): Connector {
    const existingConnector: Connector | undefined = this.connectors.find(
      (connector: Connector) => connector.target === to
    );
    if (existingConnector) {
      return existingConnector;
    }

    const connector: Connector = new Connector(this.manager, this, to);
    this.connectors.push(connector);
    return connector;
  }
}
